import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

function Footer() {
  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: 'rgba(10, 14, 23, 0.95)', 
        py: 3, 
        mt: 'auto', 
        borderTop: '1px solid rgba(255, 255, 255, 0.08)' 
      }}
    >
      <Container maxWidth="lg">
        {/* Compact Single Row Layout */}
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', md: 'row' }, 
            justifyContent: 'space-between', 
            alignItems: { xs: 'center', md: 'center' },
            gap: { xs: 2, md: 4 },
          }}
        >
          {/* Brand */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <img 
              src="/logo.png" 
              alt="ComplainAI" 
              style={{ height: '36px', width: 'auto' }} 
            />
            <Typography variant="body2" color="rgba(255, 255, 255, 0.6)" sx={{ fontSize: '0.8rem' }}>
              AI-powered dispute letters
            </Typography>
          </Box>

          {/* Links */}
          <Box 
            sx={{ 
              display: 'flex', 
              gap: { xs: 2, md: 3 }, 
              flexWrap: 'wrap', 
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Link 
              component={RouterLink} 
              to="/about" 
              underline="none" 
              sx={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '0.8rem', '&:hover': { color: '#00d4ff' } }}
            >
              About
            </Link>
            <Link 
              component={RouterLink} 
              to="/contact" 
              underline="none" 
              sx={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '0.8rem', '&:hover': { color: '#00d4ff' } }}
            >
              Contact
            </Link>
            <Link 
              component={RouterLink} 
              to="/privacy" 
              underline="none" 
              sx={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '0.8rem', '&:hover': { color: '#00d4ff' } }}
            >
              Privacy
            </Link>
            <Link 
              component={RouterLink} 
              to="/terms" 
              underline="none" 
              sx={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '0.8rem', '&:hover': { color: '#00d4ff' } }}
            >
              Terms
            </Link>
          </Box>

          {/* Social + Copyright */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <Link href="https://twitter.com" target="_blank" rel="noopener" sx={{ color: 'rgba(255, 255, 255, 0.5)', '&:hover': { color: '#00d4ff' } }}>
                <TwitterIcon sx={{ fontSize: 18 }} />
              </Link>
              <Link href="https://linkedin.com" target="_blank" rel="noopener" sx={{ color: 'rgba(255, 255, 255, 0.5)', '&:hover': { color: '#00d4ff' } }}>
                <LinkedInIcon sx={{ fontSize: 18 }} />
              </Link>
            </Box>
            <Typography variant="caption" color="rgba(255, 255, 255, 0.4)" sx={{ fontSize: '0.75rem' }}>
              © {new Date().getFullYear()} ComplainAI
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
